import React from 'react';
import { Modal, Nav, Button } from 'react-bootstrap';
import ContenidoPoliticaPrivacidad from './contenidoPoliticaPrivacidad';
import ContenidoPoliticaTratamientoDatos from './contenidoPoliticaTratamientoDatos';

export default function ModalCompanyPolicies({
  showModal,
  setShowModal,
  activeTab,
  setActiveTab,
  onAccept,
}) {
  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {activeTab === 'privacidad'
              ? 'Política de Privacidad'
              : 'Política de Tratamiento de Datos Personales'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => k && setActiveTab(k)}>
            <Nav.Item>
              <Nav.Link eventKey="privacidad">Privacidad</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="datos">Tratamiento de datos</Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="mt-3" style={{ maxHeight: 'min(70vh, 560px)', overflowY: 'auto' }}>
            {activeTab === 'privacidad' && <ContenidoPoliticaPrivacidad />}

            {activeTab === 'datos' && <ContenidoPoliticaTratamientoDatos />}
          </div>
        </Modal.Body>

        {typeof onAccept === 'function' && (
          <Modal.Footer>
            <Button variant="primary" onClick={onAccept}>
              Aceptar
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
